import { Outlet } from "react-router-dom";
import { TopBar, SiteHeader } from "@/components/site/Header";
import { SiteFooter } from "@/components/site/Footer";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { usePageContext } from "@/lib/brand";

export default function SiteLayout() {
  const { brand } = usePageContext();
  return (
    <div data-brand={brand} className="min-h-screen bg-white">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:bg-white focus:p-2">Skip to content</a>
      <TopBar />
      <SiteHeader />
      <main id="main"><Outlet /></main>
      <SiteFooter />
      <ChatWidget />
    </div>
  );
}
